import { render, staticRenderFns } from "./ReleaseDateForArticle.vue?vue&type=template&id=3f2d1d99&scoped=true&"
import script from "./ReleaseDateForArticle.vue?vue&type=script&lang=js&"
export * from "./ReleaseDateForArticle.vue?vue&type=script&lang=js&"
import style0 from "./ReleaseDateForArticle.vue?vue&type=style&index=0&id=3f2d1d99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2d1d99",
  null
  
)

export default component.exports